import { Body } from '@assembly-js/design-system';
import clsx from 'clsx';
import { useState } from 'react';

import { formatCustomFieldDate } from 'src/features/custom-fields/customFieldDate';
import { CustomFieldDatePopover } from 'src/features/custom-fields/CustomFieldDatePopover';

interface Props {
  value: unknown;
  placeholder: string;
  onSaveValue: (value: string) => void;
}

export const DateInput = ({ value, placeholder, onSaveValue }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const formatted = formatCustomFieldDate(value);

  return (
    <>
      <button
        type="button"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className="flex items-center min-h-8 w-full cursor-pointer appearance-none border-0 bg-transparent px-0"
      >
        <Body
          size="sm"
          className={clsx('leading-[21px]', {
            'text-black-heading': formatted,
            'text-light-gray': !formatted,
          })}
        >
          {formatted || placeholder}
        </Body>
      </button>
      <CustomFieldDatePopover
        anchorEl={anchorEl}
        value={value}
        onChange={onSaveValue}
        onClose={() => setAnchorEl(null)}
      />
    </>
  );
};
